import {AfterSaveContext, RepositoryDataCollection} from "@tylertech/tyler-api-types";
import { RepositoryFormData } from "../interfaces";
import { Utilities } from "@tylertech/shared-module";
/*
 * TODO - I am going to clean this up soon.
 * This is just a lazy dumping place for my misfit toys...
 *
 */
export class ObjectHelpers
{
    static isDate(value): value is Date
    {
        return value instanceof Date;
    }

    static isNumber(value: any): value is number
    {
        return isNaN(value) ? false : typeof value === "number";
    }

    /**
     * Type-safe way to check if a field that belongs to a T exists on the object.
     * @typeParam T Class or Interface that the given field exists on.
     * @param field name of field of T to check for.
     * @param obj Object to test.
     */
    static hasField<T>(field: keyof T, obj: Record<string, unknown>): boolean
    {
        return field in obj;
    }

    static isDataCollection(value: any): value is RepositoryDataCollection
    {
        // TODO - what is the bare minimum required fields for a RepositoryDataCollection?
        return (value &&
        typeof value === "object" &&
        this.hasField<RepositoryDataCollection>("Entity", value) && this.hasField<RepositoryDataCollection>("Type", value))
        /* && this.hasField<RepositoryDataCollection>("OtherEntities", value)
    && this.hasField<RepositoryDataCollection>("ReturnDataOnSave", value) */;
    }

    static isRepositoryFormData(value: any): value is RepositoryFormData
    {
        return value instanceof RepositoryFormData;
    }

    /**
     * @deprecated Just use `RepositoryFormData.create` directly
     */
    static getRepositoryFormData(rdc: RepositoryDataCollection): RepositoryFormData
    {
        return this.isRepositoryFormData(rdc) ? rdc : RepositoryFormData.create(rdc);
    }

    static isAfterSaveContext(obj: any): obj is AfterSaveContext
    {
        try
        {
            return "SaveConfirmationMessage" in obj || "DocumentsToDownload" in obj || "PostAction" in obj;
        }
        catch
        {
            return false;
        }
    }

    /**
     * Return a string representation using a safe replacer function that avoids traversing circular structures.
     * Removes any properties that start with $
     */
    static stringifyCircular(input: any, space?: string | number): string
    {
        const cache = [];
        const value = JSON.stringify(input, replacer, space);
        cache.length = 0;
        return value;
        function replacer(k: string, v): undefined | unknown
        {
            if (typeof v === "object" && v !== null)
            {
                if (cache.indexOf(v) !== -1)
                {
                    // Duplicate reference found, discard key
                    return;
                }
                // Store value in our collection
                cache.push(v);
            }
            return k.startsWith("$") ? undefined : v;
        }
    }

    /**
     * Replaces any characters that are invalid for use in JS identifiers.
     * @param value
     */
    static stripInvalidChars(value: string): string
    {
        if (Utilities.IsNullOrUndefined(value)) return value;
        // Escape \u00A0 (&nbsp;). Maybe we should escape all except 0-9a-zA-Z
        return value
            .replace(/ /g, "_")
            .replace(/[:{}\-'".,!?&%/()]/g, "")
            .replace(/\u00A0/g, "");
    }

    /**
     * Returns the value stored under the `field` key on the object `thing`.
     * If `thing` doesn't have a value for `field`, then initialize it with `newValue`;
     */
    static safeAccess<T>(thing: any, field: string, newValue: T): T
    {
        if (!thing[field])
        {
            thing[field] = newValue;
        }
        return thing[field];
    }

    static GetId(idProperty: string, model: any, index: number): string
    {
        let id: string;
        if (!Utilities.IsNullOrUndefinedOrEmpty(idProperty)) id = model[idProperty];
        else if (!Utilities.IsNullOrUndefinedOrEmpty(model["ID"])) id = model["ID"];
        else if (!Utilities.IsNullOrUndefinedOrEmpty(model["Id"])) id = model["Id"];
        else id = "" + index;
        if (model["SerializedRowState"] === "Added" && Utilities.IsNullOrUndefinedOrZero(id))
        {
            if (!Utilities.IsNullOrUndefined(model["$$AddedRowId"])) return model["$$AddedRowId"];
            id = "$$" + index;
            model["$$AddedRowId"] = id;
        }
        return id;
    }
}
